<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <div class="d-flex justify-content-between">
               <div class="d-flex justify-content-between w-100">
                 <h2 style="font-size: 1.2vw !important;width: 14vw;">لیست شرکت های تابعه</h2>

               </div>

                <p class="d-flex flex-column align-items-end">
                  


                  <button @click="$router.go(-2)" v-if="false" style="width: 5vw; margin-top: 0.8vw;"   class="btn btn-primary btn-back">
                    برگشت
                  </button>


                  <router-link v-if="$router.options.history.state.back === '/process/map'" to="/process/map_self" class="btn btn-primary btn-back mt-2">
                    تعریف فرآیند ها
                  </router-link>
                  <router-link v-if="$router.options.history.state.back === '/job/evaluation'" to="/job/evaluation/by/self" class="btn btn-primary btn-back mt-2">
                    تعریف کارسنجی
                  </router-link>
                </p>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <input v-model="searchUser" type="text" class="form-control" style="width: 20vw;" placeholder="جستجو بر اساس نام شرکت...">
                <button @click="addNewMethod" class="btn btn-primary btn-submit-1">افزودن </button>
              </div>

            <hr>
            </div>
            <center class="mt-3" v-if="!all_users.length">
              شرکتی یافت نشد
            </center>
            <div v-if="all_users.length" class="table-responsive mt-3">
              <div style="overflow-y: scroll; height: 50vw;" :style="all_users.length < 19 ? 'height: auto;' : ''">

              <table v-if="all_users" class="table table-striped">
                <thead>
                <tr>
                  <th style="width: 1vw;">ردیف</th>
                  <th>نام  </th>
                  <th v-if="false" style="width: 17vw;">  مشاهده  </th>
                  <th>نام و نام خانوادگی  </th>
                  <th>نام کاربری  </th>
                  <th  style="width:7vw;">پست سازمانی</th>
                  <th  style="width: 5vw;">فرآیند ها</th>
                  <th  style="width: 5vw;">فعالیت ها</th>
                  <th  style="width: 5vw;">عملیات</th>

                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in filteredItems" :key="item.id">
                  <td scope="row">{{ index + 1 }}</td>
                  <td>{{ item['name'] }}</td>
                  <td>{{ item.user && item.user.fullname }}</td>
                  <td>{{ item.user && item.user.username }}</td>



                  <td>
                    <button  style="width: 7vw;" class="btn btn-primary btn-add-org-post" :style="!item.complate_organ ? 'background: #7FFFD4' : ''">
                      <span v-if="item.complate_organ">منتشر شده</span>
                      <span   v-else @click.prevent="submitCloneOrganMethod(item.id)">انتشار</span>

                    </button>
                  </td>
                  <td>
                   <div v-if="!item.complate_organ">--</div>
                   <div v-else>
                     <button   style="width: 5vw;" class="btn btn-primary btn-add-org-post" :style="!item.complate_process ? 'background: #7FFFD4' : ''">
                       <span v-if="!item.complate_process" @click.prevent="submitCloneProcessMethod(item.id)">انتشار</span>
                       <span v-else >منتشر شده</span>
                     </button>
                   </div>

                  </td>
                  <td>
                    <div v-if="!item.complate_process">--</div>
                    <div v-else-if="!item.complate_process"></div>
                    <div v-else>
                      <button style="width: 5vw;" class="btn btn-primary btn-add-org-post" :style="!item.complate_task ? 'background: #7FFFD4' : ''">
                        <span v-if="!item.complate_task" @click.prevent="submitCloneTaskMethod(item.id)">انتشار</span>
                        <span v-else >منتشر شده</span>
                      </button>
                    </div>

                  </td>
                  <td  >
                    <a @click.prevent="edit(item['id'])" href="#"><img class="table-edit-img"
                                                                       src="../../../assets/img/pen.svg" alt="edit"></a>
                    &nbsp;
                    <a @click.prevent="deleteItem(item['id'])" href="#"><img class="table-delete-img mr-1"
                                                                             src="../../../assets/img/delete.svg"
                                                                             alt="delete"></a>
                  </td>

                </tr>

                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="addNew || editModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p v-if="!editModal">افزودن جدید</p>
      <p v-else>ویرایش  </p>
      <p v-if="!editModal" @click="addNew=!addNew">❌</p>
      <p v-else @click="editModal=!editModal">❌</p>
    </div>
    <div>
      <div class="d-flex flex-row">
        <div  >
          <label class="required">نام شرکت
          </label>
          <input v-model="company_name" type="text" class="form-control">
        </div>
        <div  class="mx-3">
          <label class="required">نام و نام خانوادگی ادمین شرکت
          </label>
          <input v-model="fullname" type="text" class="form-control">
        </div>
      </div>

      <div class="d-flex flex-row my-2">
      <div  >
          <label class="required">نام کاربری
          </label>
          <input v-model="username" type="text" class="form-control">
        </div>
        <div  class="mx-3">
          <label   :class="addNew ? 'required' : ''">
            رمز عبور
          </label>
          <input v-model="nationalCode" type="text" class="form-control">
        </div>

      </div>
      <div class="d-flex flex-row my-2 col-12">

        <div  class="mx-3 w-100">
          <label class="">شماره تلفن
          </label>
          <input v-model="phone" type="text" class="form-control">
        </div>
        </div>
      <div  class="mx-3 " style="width: 24vw;" v-if="false">
          <label >
           کپی کردن از شرکت های زیر
          </label>
        <select v-model="copy_id" class="form-select">
          <option value="" disabled selected>انتخاب کنید</option>
          <option v-for="item in all_users" :value="item.id">{{item.name}}</option>
        </select>
        </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button v-if="!editModal" @click="addNew=!addNew" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button v-else @click="editModal=!editModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <div v-if="!editModal" style="width: unset;">
          <button v-if="!is_load_submit"  class="btn btn-primary btn-approve" @click="store">تایید</button>
          <button v-if="is_load_submit"  class="btn btn-primary btn-approve disabled" style="width: 10vw;" >لطفا منتظر بمانید...</button>
        </div>
        <button v-else class="btn btn-primary btn-approve" @click="update(id)">ویرایش</button>
      </div>
  </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="cloneAllModal" style="z-index: 999999999999999">
    <div>
      <p>اطلاعیه</p>
      <p @click="cloneAllModal=!cloneAllModal">❌</p>
    </div>
    <div>
      <p style="background-color:#fff; padding: 1vw; text-align: right; border-radius: 1vw;">آیا میخواهید موارد در تمامی شرکت های زیرمجموعه ایجاد شود؟</p>
      <button v-if="!is_load" @click="submitCloneAll">تایید</button>
      <button style="width: 28vw !important;"  disabled v-else>در حال کپی کردن فرآیند ها و فعالیت ها در شرکت های تابعه...</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top"   style="z-index: 999999999999999" v-show="submitCloneOrganModal">
    <div>
      <p>اطلاعیه</p>
      <p @click="submitCloneOrganModal=!submitCloneOrganModal">❌</p>
    </div>
    <div>
      <p style="background-color:#fff; padding: 1vw; text-align: right; border-radius: 1vw;">آیا میخواهید پست های سازمانی در  شرکت  تابعه ایجاد شود؟</p>
      <button v-if="!is_load" @click="submitCloneOrgan">تایید</button>
      <button style="width: 28vw !important;"  disabled v-else>در حال کپی کردن پست سازمانی در شرکت  تابعه...</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top"   style="z-index: 999999999999999" v-show="submitCloneProcessModal">
    <div>
      <p>اطلاعیه</p>
      <p @click="submitCloneProcessModal=!submitCloneProcessModal">❌</p>
    </div>
    <div>
      <p style="background-color:#fff; padding: 1vw; text-align: right; border-radius: 1vw;">آیا میخواهید فرآیند ها در  شرکت  تابعه ایجاد شود؟</p>
      <button v-if="!is_load" @click="submitCloneProcess">تایید</button>
      <button style="width: 28vw !important;"  disabled v-else>در حال کپی کردن فرآیند ها   در شرکت  تابعه...</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top"   style="z-index: 999999999999999" v-show="submitCloneTaskModal">
    <div>
      <p>اطلاعیه</p>
      <p @click="submitCloneTaskModal=!submitCloneTaskModal">❌</p>
    </div>
    <div>
      <p style="background-color:#fff; padding: 1vw; text-align: right; border-radius: 1vw;">آیا میخواهید فعالیت ها در  شرکت  تابعه ایجاد شود؟</p>
      <button v-if="!is_load" @click="submitCloneTask">تایید</button>
      <button style="width: 28vw !important;"  disabled v-else>در حال کپی کردن فعالیت ها در شرکت  تابعه...</button>
    </div>
  </div>
</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import cookies from "vue-cookies";
import router from "@/router";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  name: "ListUser",
  components: {Sidebar, Splash,},
  data() {
    return {
      all_users: [],
      searchUser:'',
      addNew: false,
      cloneAllModal: false,
      editModal: false,
      deleteModal: false,
      id: '',
      phone: '',
      password: '',
      username: '',
      national_code: '',
      fullname: '',
      company_name: '',
      personalCode: '',
      nationalCode: '',
      copy_id: '',
      is_load: false,
      is_load_submit: false,
      submitCloneOrganModal: false,
      submitCloneProcessModal: false,
      submitCloneTaskModal: false,
    }
  },
  methods: {
    submitCloneTask(){
      this.is_load =true
      fetch(`${this.base_url}/user/clone_task_process/${this.copy_id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              this.is_load =false
              return
            }
            if (response.message){
              this.submitCloneTaskModal = false
              toast.success(response.message)
              this.is_load =false
              this.fetchItems()


            }

          }).catch((err) => {
      })
    },
    submitCloneTaskMethod(id){
      this.copy_id = id
      this.submitCloneTaskModal = true
    },
    submitCloneProcess(){
      this.is_load =true
      fetch(`${this.base_url}/user/clone_process/${this.copy_id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              this.is_load =false
              return
            }
            if (response.message){
              this.submitCloneProcessModal = false
              toast.success(response.message)
              this.is_load =false
              this.fetchItems()
            }

          }).catch((err) => {
      })
    },
    submitCloneProcessMethod(id){
      this.copy_id = id
      this.submitCloneProcessModal = true
    },
    submitCloneOrganMethod(id){
      this.copy_id = id
      this.submitCloneOrganModal = true
    },
    submitCloneOrgan(){
      this.is_load =true
      fetch(`${this.base_url}/user/clone_organ/${this.copy_id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              this.is_load =false
              return
            }
              if (response.message){
                this.submitCloneOrganModal = false
                toast.success(response.message)
                this.is_load =false
                this.fetchItems()

              }

          }).catch((err) => {
      })

    },
    cloneAll(){
      this.cloneAllModal = true
    },
    submitCloneAll(){
      this.is_load =true
      fetch(`${this.base_url}/processes/store_by_mother`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.message){


            }

          }).catch((err) => {
      })
      fetch(`${this.base_url}/tasks_process/store_clone`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.message){
              this.cloneAllModal = false
              toast.success(response.message)
              this.is_load =false

            }

          }).catch((err) => {
      })
    },
    resetAll(){
      this.is_load_submit =false
      this.company_name = ''
      this.username = ''
      this.fullname = ''
      this.phone = ''
      this.personalCode =''
      this.copy_id =''
      this.national_code =''
      this.nationalCode =''
    },
    edit(id) {
      this.resetAll()
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/edit_company/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.editModal = true
            this.id = id
            const item = result['item']
            if (item) {
              this.national_code = item.user.national_code
              this.company_name = item.name
              this.username = item.user.username
              this.fullname = item.user.fullname
              this.phone = item.user.phone
              this.personalCode = item.user.personal_code

            }

          })
          .catch();
    },
    deleteItem(id){
      this.id = id
      this.deleteModal=true
    },

    deleteItemForm(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/delete_company/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.Error= true
              this.ErrorM= result.error
              toast.error(this.ErrorM)
            }
            this.deleteModal = false
            this.fetchItems()

          })
          .catch();

    },

    store(){
      this.is_load_submit =true
      if (!this.company_name){
        toast.error('نام شرکت اجباری است!')
      this.is_load_submit =false
        return;
      }
      else if (!this.fullname){
        toast.error('نام و نام خانوادگی اجباری است!')
      this.is_load_submit =false
        return;
      }
      else if (!this.username){
        toast.error('نام کاربری اجباری است!')
      this.is_load_submit =false
        return;
      }
      else if (!this.nationalCode){
        toast.error('رمز عبور اجباری است!')
      this.is_load_submit =false
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('name',this.company_name)
      formdata.append('username',this.username)
      formdata.append('fullname',this.fullname)
      formdata.append('password',this.nationalCode)
      formdata.append('phone',this.phone)
      formdata.append('personal_code',this.personalCode)
      formdata.append('copy_id',this.copy_id)
      formdata.append('national_code',this.national_code)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/user/new`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.is_load_submit =false
              return;
            }
            toast.success(response.message)
            this.fetchItems()
            this.addNew=false
            this.resetAll()
            this.is_load_submit =false




          })
          .catch();
    },
    update(){
      if (!this.company_name){
        toast.error('نام شرکت اجباری است!')
        this.is_load_submit =false
        return;
      }
      else if (!this.fullname){
        toast.error('نام و نام خانوادگی اجباری است!')
        this.is_load_submit =false
        return;
      }
      else if (!this.username){
        toast.error('نام کاربری اجباری است!')
        this.is_load_submit =false
        return;
      }

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('name',this.company_name)
      formdata.append('username',this.username)
      formdata.append('fullname',this.fullname)
      formdata.append('password',this.nationalCode)
      formdata.append('phone',this.phone)
      formdata.append('personal_code',this.personalCode)
      formdata.append('national_code',this.national_code)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/user/update_company/${this.id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.fetchItems()
            this.editModal = false
            this.resetAll()


          })
          .catch();
    },
    addNewMethod(){
      this.resetAll()
      this.addNew=!this.addNew
    },

    fetchItems() {
      this.all_users.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/all_for_mother`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result['users'].length !== 0) {
              result['users'].forEach(item => {
                this.all_users.push(item)

              })

            }

          })
          .catch();
    },

    checkIsMother(){
     if (!this.is_mother){
       router.push('/')
     }


    }
  },
  mounted() {
    this.checkIsMother()
    this.fetchItems()
  },
  computed:{
    filteredItems() {
      return this.all_users.filter(item => {
        return (
    item['name'].includes(this.searchUser)
        );
      });
    },
  }
}
</script>

<style scoped lang="scss">
label {
  width: 100%;
  text-align: right;
}



p, label {
  font-size: 1vw !important;
}

input[type=checkbox] {
  width: 1vw;
  height: 1vw;
  border-radius: .5vw;
  border: .2vw solid #eee;
}

.text-end {
  font-weight: bold;
}
.change_div{
  background: #fff;
  width: 20vw;
  padding: 1vw;
  margin-left: 5vw;
  border-radius: 1vw;
}
.btn-add-org-post:hover{
  color: #fff;
}
</style>